module.exports = __webpack_public_path__ + "img/wa.af2c0196.svg";